import { useCallback } from 'react';
import { pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const useShowLowBalancePopup = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const closePopups = useSmartClosePopups();
    const { lowBalanceAlertWcId, depositPage } = useAppSelector(pick(['lowBalanceAlertWcId', 'depositPage']));

    return useCallback((): void => {
        dispatch(showCommonPopupAction({
            articleId: lowBalanceAlertWcId,
            buttons: [
                {
                    text: 'playtech.mobile.system.deposit',
                    onClick: () => {
                        closePopups();
                        navigate(depositPage);
                    }
                }
            ]
        }));
    }, [closePopups, depositPage, lowBalanceAlertWcId, navigate, dispatch]);
};
